import { css } from '@emotion/core'
import styled from '@emotion/styled'

import { Color } from '../../../../enums/color'
import { DefaultValue } from '../../../../enums/defaultValue'
import { Spacing } from '../../../../enums/spacing'
import { getDefaultTransition } from '../../../../utils/getDefaultTransition'

type ControlProps = {
  hasLargePadding: boolean
}

export const Control = styled.div<ControlProps>`
  display: flex;
  align-items: center;
  gap: ${Spacing.S8};
  justify-content: center;
  height: 100%;
  padding: ${({ hasLargePadding }) => (hasLargePadding ? `0 ${Spacing.S16}` : ` 0 ${Spacing.S8}`)};
  border-radius: ${DefaultValue.BorderRadius};
  ${getDefaultTransition('background')}
`

export const NativeRadio = styled.input`
  opacity: 0;
  width: 1px;
  height: 1px;
  position: absolute;
  top: 0;
  left: 0;
  pointer-events: none;
`

interface ToggleGroupItemWrapperProps {
  checked: boolean
  disabled?: boolean
}

export const ToggleGroupItemWrapper = styled.label<ToggleGroupItemWrapperProps>`
  display: flex;
  height: 100%;
  position: relative;
  cursor: pointer;

  ${({ checked }) =>
    checked &&
    css`
      ${Control} {
        background-color: ${Color.White};
      }
    `}

  ${({ disabled }) =>
    disabled &&
    css`
      cursor: not-allowed;
    `}
`
